import { render, staticRenderFns } from "./AssignCoachEditTabInformation.vue?vue&type=template&id=c1658562&"
import script from "./AssignCoachEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./AssignCoachEditTabInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports